import React from 'react';
import moment from 'moment';

import styles from './attachmentsStyles.scss';

import CollapsiblePanel from './collapsiblePanel';
import Link from 'buyside/components/presentation/Link/link';

import { getExtensionIcon } from 'buyside/util/fileHelper';
import { ideaAttachmentUrl } from 'buyside/util/urlHelper';

import { IdeaAttachmentsQuery } from 'interfaces/graphql-typings';

const CollapsibleAttachments: React.FC<{
  dataTag?: string;
  files: IdeaAttachmentsQuery['idea']['ideaAttachments'];
  Icon: React.SVGFactory;
  researchType: string;
}> = ({ dataTag, files, Icon, researchType }) => {
  const attachmentTypes = [...new Set(files?.map(file => file.attachmentType))].sort();

  const researchTypeHeader = (
    <div>
      <Icon className={styles.titleIcon} />
      {researchType} ({files?.length})
    </div>
  );

  return (
    <CollapsiblePanel dataTag={dataTag} title={researchTypeHeader}>
      {attachmentTypes.map(
        (type): React.ReactElement => (
          <div key={type} className={styles.attachmentTypeContainer}>
            <div>{type}</div>
            <div>
              {files
                ?.filter((file): boolean => file.attachmentType === type)
                .map(
                  ({ id, createdAt, filename, fileType }): React.ReactElement => {
                    const Icon = getExtensionIcon(fileType);
                    const fileNameLink = (
                      <Link to={ideaAttachmentUrl(id)} target="_blank">
                        <Icon className={styles.attachmentIcon} />
                        {filename}
                      </Link>
                    );

                    return (
                      <div key={id} className={styles.fileInfo}>
                        <div>{fileNameLink}</div>
                        <div>{moment(createdAt).format('M/D/YY')}</div>
                      </div>
                    );
                  }
                )}
            </div>
          </div>
        )
      )}
    </CollapsiblePanel>
  );
};

export default CollapsibleAttachments;
